import { t } from 'i18next'
import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const TITLE = 'title'
const TEXT = 'text'
const SHOW_FROM_DATETIME = 'show_from_datetime'
const SHOW_TO_DATETIME = 'show_to_datetime'
const RECIPIENTS = 'recipients'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [TEXT]: {
      label: `${t('common.text')}`,
      name: TEXT,
      required: true,
    },
    [SHOW_FROM_DATETIME]: {
      label: `${t('common.show-from-datetime')}`,
      name: SHOW_FROM_DATETIME,
      required: true,
    },
    [SHOW_TO_DATETIME]: {
      label: `${t('common.show-to-datetime')}`,
      name: SHOW_TO_DATETIME,
      required: true,
    },
    [RECIPIENTS]: {
      label: `${t('common.recipients')}`,
      name: RECIPIENTS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [TEXT]: '',
  [SHOW_FROM_DATETIME]: '',
  [SHOW_TO_DATETIME]: '',
  [RECIPIENTS]: []
}
/**
 * Form data validation
 */
 export const validationSchema = () =>
 yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [TEXT]: yup.string().required(`${t('errors.required-error-message')}`),
    [SHOW_FROM_DATETIME]: yup.date().required(`${t('errors.required-error-message')}`),
    [SHOW_TO_DATETIME]: yup.date().required(`${t('errors.required-error-message')}`),
 })

export default formModel
